import { css } from 'styled-components';
import { CFMixins } from '../../../mixins';
import { CFTokens } from '../../../tokens';
import { CFBaseSegmentControlsTokens } from '../';
export const labelStyles = ({ $selected = false, $size = 'md', $variant = 'strong', }) => {
    const fontColor = CFBaseSegmentControlsTokens.SEGMENT_CONTROL_LABEL_COLOR[$variant][$selected ? 'SELECTED' : 'DEFAULT'];
    return css `
    color: ${fontColor};
    ${CFMixins.typeSpec(CFBaseSegmentControlsTokens.SEGMENT_CONTROL_TYPE_SPEC[$size])}
  `;
};
export const rootBackground = ({ $selected = false, $variant = 'strong', }) => {
    if ($selected) {
        if ($variant === 'strong')
            return CFTokens.COLOR.INTERACTIVE_DEFAULT;
        if ($variant === 'subtle')
            return CFTokens.COLOR.BACKGROUND_POP;
        if ($variant === 'alternate')
            return CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT;
        return;
    }
    return CFTokens.COLOR.TRANSPARENT;
};
export const rootHeight = ({ $size = 'md' }) => {
    return CFBaseSegmentControlsTokens.SEGMENT_CONTROL_SIZE[$size];
};
export const rootPadding = ({ $size = 'md', $withBadge = false, }) => {
    const leftPadding = CFBaseSegmentControlsTokens.SEGMENT_CONTROL_PADDING_HORIZONTAL[$size];
    const rightPadding = $withBadge
        ? CFBaseSegmentControlsTokens.SEGMENT_CONTROL_PADDING_HORIZONTAL_WITH_BADGE[$size]
        : leftPadding;
    return `0 ${rightPadding}px 0 ${leftPadding}px`;
};
export const rootWebInteractions = ({ $selected = false, $variant = 'strong', }) => {
    return $selected
        ? ``
        : css `
        &:hover {
          background-color: ${$variant === 'alternate'
            ? CFTokens.COLOR.INTERACTIVE_ALTERNATE_HOVER_SECONDARY
            : CFTokens.COLOR.INTERACTIVE_HOVER_SECONDARY};
          color: ${$variant === 'alternate'
            ? CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT
            : CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT};
        }
      `;
};
